export default {
  bind (el, binding) {
    binding.def.methods.init(el)
  },

  methods: {
    init (el) {
      const input = el.querySelector('input')
      const label = el.querySelector('label')

      input.addEventListener('change', ($event) => this.change($event, label))
    },

    change ($event, label) {
      const labelText = label.innerHTML
      let fileName = $event.target.value.split('\\').pop()

      if (fileName === '') {
        fileName = labelText
      }

      label.innerHTML = fileName
      label.setAttribute('title', fileName)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/custom-file-input.js